import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MessageService {
    constructor(
        private snackBar: MatSnackBar,
        private translateService: TranslateService
    ) { }

    public log(message: string, delay = 1500): void {
        console.log(message);

        this.translateService.get(message).subscribe(translatedMessage => {
            this.snackBar.open(
                translatedMessage, 'Ok',
                {
                    horizontalPosition: 'end',
                    verticalPosition: 'bottom',
                    duration: delay,
                }
            );
        })

    }
}

